import React, {
  Fragment,
  ReactElement,
  FunctionComponent,
  useState,
  MouseEvent,
} from "react";
import WDVerticalScroll from "./WDVerticalScroll";
import t from "../../i18n";
import Move from "../../assets/help/move.gif";
import Convoy from "../../assets/help/convoy.gif";
import Hold from "../../assets/help/hold.gif";
import SupportHold from "../../assets/help/support-hold.gif";
import SupportMove from "../../assets/help/support-move.gif";
import Retreat from "../../assets/help/retreat.gif";
import Build from "../../assets/help/build.gif";
import ViaConvoy from "../../assets/help/via-convoy.gif";

import { ReactComponent as BtnArrowIcon } from "../../assets/svg/btnArrow.svg";

interface itemProps {
  title: string;
  image: any;
  description: string;
  shortcutKey: string;
}

interface HelpProps {
  gameID: number;
}

const items: itemProps[] = [
  {
    title: t("Move"),
    image: Move,
    description: t(
      "Select Unit (or territory), select Move, select Destination Territory.",
    ),
    shortcutKey: "m or a",
  },
  {
    title: t("Convoy"),
    image: Convoy,
    description: t(
      "Select Army (or territory), select Convoy, select Destination Territory.",
    ),
    shortcutKey: "c",
  },
  {
    title: t("Via Convoy"),
    image: ViaConvoy,
    description: t(
      "Select Army (or territory), select Via Convoy, select Destination Territory.",
    ),
    shortcutKey: "v",
  },
  {
    title: t("Hold"),
    image: Hold,
    description: t("Select Unit or territory, select Hold."),
    shortcutKey: "h or d",
  },
  {
    title: t("Support Hold"),
    image: SupportHold,
    description: t(
      "Select Supporting Unit (or territory), select Support, select Unit (or territory) to Support.",
    ),
    shortcutKey: "",
  },
  {
    title: t("Support Move"),
    image: SupportMove,
    description: t(
      "Select Supporting Unit (or territory), select Support, select Unit (or territory) to Support, select Destination Territory.",
    ),
    shortcutKey: "s",
  },
  {
    title: t("Retreat"),
    image: Retreat,
    description: t(
      "Select Unit (or territory), select Retreat, select Destination Territory.",
    ),
    shortcutKey: "",
  },
  {
    title: t("Build"),
    image: Build,
    description: t(
      "Select supply center territory, select type of unit (Army or Fleet).",
    ),
    shortcutKey: "",
  },
];

const WDHelp: FunctionComponent<HelpProps> = function ({
  gameID,
}): ReactElement {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const suspicionLink = `/board.php?gameID=${gameID}&view=dropDown&lodgeSuspicion=on`;
  return (
    <WDVerticalScroll>
      <div className="mt-3 px-3 sm:px-4">
        <div className="text-lg font-bold">{t("Using the UI:")}</div>
        {items.map((item: itemProps, index: number) => (
          <Fragment key={item.title}>
            {currentIndex === index && (
              <>
                <div
                  className="w-full h-48 bg-cover bg-center rounded-2xl"
                  style={{ backgroundImage: `url(${item.image})` }}
                />
                <div className="flex mt-4 mb-2">
                  <div className="flex-1 text-lg font-bold">{item.title}</div>
                  <div className="flex">
                    <button
                      className="mr-1"
                      type="button"
                      onClick={(event: MouseEvent<HTMLButtonElement>) => {
                        event.stopPropagation();
                        if (index > 0) {
                          setCurrentIndex(index - 1);
                        }
                      }}
                    >
                      <BtnArrowIcon
                        className={`text-black stroke-white ${
                          index === 0 && "text-gray-300 cursor-not-allowed"
                        }`}
                      />
                    </button>
                    <button
                      type="button"
                      onClick={(event: MouseEvent<HTMLButtonElement>) => {
                        event.stopPropagation();
                        if (index < items.length - 1) {
                          setCurrentIndex(index + 1);
                        }
                      }}
                    >
                      <BtnArrowIcon
                        className={`scale-y-[-1] text-black stroke-white ${
                          index === items.length - 1 &&
                          "text-gray-300 cursor-not-allowed"
                        }`}
                      />
                    </button>
                  </div>
                </div>
                <div>
                  {item.description}{" "}
                  {item.shortcutKey && (
                    <span>
                      {t("Shortcut Key:")}{" "}
                      <span className="font-bold">{item.shortcutKey}</span>
                    </span>
                  )}
                </div>
              </>
            )}
          </Fragment>
        ))}
      </div>
      <div className="mt-3 px-3 sm:px-4">
        <hr />
        <div className="mt-4 mb-2">
          <div className="text-lg font-bold">{t("Helpful information:")}</div>
          <div>
            <ul>
              <li>
                To find out how points and scoring works:
                <br />
                <a href="points.php" className="text-blue-500">
                  <b>{t("Guide to points / scoring")}</b>
                  <br />
                  <br />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-3 px-3 sm:px-4">
        <hr />
        <div className="mt-4 mb-2">
          <div className="text-lg font-bold">{t("Requesting help:")}</div>
          <div>
            <ul>
              <li>
                If you have a reason to suspect other player(s) of cheating /
                rule breaking / collusion:
                <br />
                <a href={suspicionLink} className="text-blue-500">
                  <b>{t("Lodge a cheating suspicion")}</b>
                  <br />
                  <br />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </WDVerticalScroll>
  );
};

export default WDHelp;
